export default __webpack_public_path__ + "static/media/aboutUs-abvtex@2x.e9847658.png";